'use client';

import React from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import './carouselStyle.css';
import AutoScroll from 'embla-carousel-auto-scroll';

const Carousel = ({ children, className, play = true, infinity = true }) => {
  const [emblaRef] = useEmblaCarousel({ loop: infinity }, [AutoScroll({ playOnInit: play })]);

  return (
    <div className="embla" ref={emblaRef}>
      <div className={`${className} embla__container flex gap-3`}>{children}</div>
    </div>
  );
};

export default Carousel;
